<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaPromotor />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import ListaPromotor from "../Components/Listagens/ListaPromotor.vue";
export default {
  name: "ListPromoter",
  components: {
    ListaPromotor,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>